const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL,
  RSA_KEY: process.env.REACT_APP_RSA_PUBLIC_KEY,
};
export { CONFIG };
